import axios from 'axios'

import { API_URL } from '@goodfellas/environment'

import { goodfellasApi } from '../apis'

function extractError(error: unknown): { status?: number; message?: string } {
  if (axios.isAxiosError(error)) {
    return {
      status: error.response?.status,
      message:
        error.response?.data?.message ??
        error.response?.data?.error ??
        error.message,
    }
  }
  return { message: error instanceof Error ? error.message : String(error) }
}

export type SendCodeResult =
  | { ok: true }
  | { ok: false; status?: number; message?: string }

export const sendSsoCode = async (phone: string): Promise<SendCodeResult> => {
  try {
    const response = await goodfellasApi.post(
      `${API_URL}authenticate/sso/sendCode`,
      {
        phone,
      },
    )

    if (response.status !== 200) {
      throw new Error(`HTTP error Status: ${response.status}`)
    }

    return { ok: true }
  } catch (error) {
    return { ok: false, ...extractError(error) }
  }
}

export const verifySsoCode = async (phone: string, code: string) => {
  try {
    const response = await goodfellasApi.post<{ token: string }>(
      `${API_URL}authenticate/sso/verifyCode`,
      { phone, code },
    )

    if (response.status !== 200) {
      throw new Error(`HTTP error Status: ${response.status}`)
    }

    return response.data
  } catch (_error) {
    return null
  }
}

export const verifyPhoneLogin = async (phone: string) => {
  try {
    const response = await goodfellasApi.get<{ verify: boolean }>(
      `${API_URL}authenticate/sso/verifyPhoneLogin`,
      { params: { phone } },
    )

    if (response.status !== 200) {
      throw new Error(`HTTP error Status: ${response.status}`)
    }

    return response.data
  } catch (_error) {
    return null
  }
}

export const verifyRecoverPassword = async (phone: string, code: string) => {
  try {
    const response = await goodfellasApi.post<{ token: string }>(
      `${API_URL}authenticate/sso/verifyRecoverCode`,
      { phone, code },
    )

    if (response.status !== 200) {
      throw new Error(`HTTP error Status: ${response.status}`)
    }

    return response.data
  } catch (_error) {
    return null
  }
}

export const sendRecoverPasswordCode = async (
  phone: string,
): Promise<SendCodeResult> => {
  try {
    const response = await goodfellasApi.post(
      `${API_URL}authenticate/sso/sendRecoverCode`,
      { phone },
    )

    if (response.status !== 200) {
      throw new Error(`HTTP error Status: ${response.status}`)
    }

    return { ok: true }
  } catch (error) {
    return { ok: false, ...extractError(error) }
  }
}
